import axios from 'axios'
import {TextField} from 'formik-material-ui'
import React, {Fragment, useState} from 'react'
import {Dialog, Grid, Grow, Typography} from '@material-ui/core'
import {Field, useFormikContext} from 'formik'
import NotFound from '../../../../assets/map_flatline.png'
import MaskField from '../../../../components/MaskField'
import SelectField from '../../../../components/SelectField'
import {FEDERATIVE_UNITIES} from '../../../../constants'

import {StepHeader} from '../../styles'

const Step7 = () => {
  const [zipNotFoundOpen, setZipNotFoundOpen] = useState(false)
  const {setFieldValue} = useFormikContext()
  return (
    <Fragment>
      <Dialog
        open={zipNotFoundOpen}
        onClose={() => setZipNotFoundOpen(false)}
        image={NotFound}
        title="Endereço não encontrado"
        description="Não foi possível encontrar o endereço para o cep informado, por favor verifique os dados e tente novamente."
        actionText="Fechar"
      />
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 2 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Dados da empresa
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              name="zip"
              type="tel"
              mask="99999-999"
              onBlur={async (event) => {
                try {
                  const zip = event.target.value.replace('-', '')
                  const {data} = await axios.get(`https://api.postmon.com.br/v1/cep/${zip}`)
                  const {logradouro, bairro, estado, cidade} = data
                  setFieldValue('street', logradouro, true)
                  setFieldValue('federativeUnit', estado, true)
                  setFieldValue('neighborhood', bairro, true)
                  setFieldValue('city', cidade, true)
                  setFieldValue('country', 'Brasil', true)
                } catch (e) {
                  setZipNotFoundOpen(true)
                }
              }}
              label="Qual é o seu CEP?"
              helperText="É para lá que vamos enviar seu cartão."
              fullWidth
              component={MaskField}
            />
          </Grid>
          <Grid item xs={8}>
            <Field
              name="street"
              type="text"
              label="Logradouro"
              fullWidth
              component={TextField}
            />
          </Grid>
          <Grid item xs={4}>
            <Field
              name="number"
              type="text"
              label="Número"
              fullWidth
              component={TextField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="complement"
              type="text"
              label="Complemento"
              fullWidth
              component={TextField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="neighborhood"
              type="text"
              label="Bairro"
              fullWidth
              component={TextField}
            />
          </Grid>
          <Grid item xs={4}>
            <Field
              name="city"
              type="text"
              label="Cidade"
              fullWidth
              component={TextField}
            />
          </Grid>
          <Grid item xs={4}>
            <Field
              label="Estado"
              native
              name="federativeUnit"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              {FEDERATIVE_UNITIES.map(({label, value}) => (
                <option value={value}>{label}</option>
              ))}
            </Field>
          </Grid>
          <Grid item xs={4}>
            <Field
              name="country"
              type="text"
              label="País"
              fullWidth
              component={TextField}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  )
}

export default Step7
